import React from "react";
import Question from "../components/quizPage"




const Quiz = () => {
return (
	<div>
		<Question/>
	</div>
);
};

export default Quiz;
